const s = (t) => {
  const e = t.toString();
  for (let r = 0; r < e.length; r++) {
    const n = e[r];
    if (n === "." || n === ",")
      return e.length - r - 1;
  }
  return -1;
}, u = (t) => /.*\d.*/.test(t), o = (t) => !Number.isNaN(t), m = (t) => {
  var e = /^[-+]?(\d*\.\d+|\d+\.\d*[1-9])$/;
  return e.test(t);
}, c = (t) => {
  var e = /^[-+]?\d+$/;
  return e.test(t);
}, i = (t) => {
  const e = t / 1e3;
  return e > 10 ? Math.round(e) : e.toFixed(1);
};
export {
  i as convertMetersToKm,
  s as getNumberOfDecimals,
  u as hasNumbers,
  m as isDecimalNumber,
  o as isNumber,
  c as isWholeNumber
};
